// extracted by mini-css-extract-plugin
export default {"outerDiv":"SuccessStories_outerDiv__btuhR","sucessImage":"SuccessStories_sucessImage__hpZCj","successInfo":"SuccessStories_successInfo__PNEgV"};